export default "__VITE_ASSET__B9KtfG9d__"